import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class DashboardProgressBarController extends Controller {
  static values = {
    minMomentum: { type: Number },
    maxMomentum: { type: Number },
    minMastery: { type: Number },
    maxMastery: { type: Number },
    momentumMaxDash: { type: Number },
    momentumLength: { type: Number },
    masteryMaxDash: { type: Number },
    masteryLength: { type: Number },
    registrationDate: { type: Number }
  }

  static targets = ['momentum', 'mastery', 'masteryPercent', 'masteryPercentMobile', 'momentumText', 'momentumTextMobile', 'momentumPercent']

  connect () {
    this.#setProgressValues()
  }

  reconnect () {
    this.#setProgressValues()
  }

  #setProgressValues () {
    this.#updateProgress(this.masteryTarget, this.minMasteryValue, this.maxMasteryValue, this.masteryMaxDashValue, this.masteryLengthValue)
    this.#updateProgress(this.momentumTarget, this.minMomentumValue, this.maxMomentumValue, this.momentumMaxDashValue, this.momentumLengthValue)
    this.#updateMasteryPercent()
    this.#updateMomentumText()
    this.#updateMomentumPercent()
  }

  #updateProgress (target, minValue, maxValue, maxDash, totalLength) {
    const progress = maxValue === 0 ? 0 : (minValue / maxValue) * 100
    const dash = Math.min((progress / 100) * maxDash, maxDash)
    target.setAttribute('stroke-dasharray', `${dash} ${totalLength}`)
    return progress
  }

  #updateMasteryPercent () {
    const progress = this.#updateProgress(this.masteryTarget, this.minMasteryValue, this.maxMasteryValue, this.masteryMaxDashValue, this.masteryLengthValue)
    const masteryPercent = `${Math.round(progress)}%`
    if (this.hasMasteryPercentTarget) {
      this.masteryPercentTarget.textContent = masteryPercent
    }
    if (this.hasMasteryPercentMobileTarget) {
      this.masteryPercentMobileTarget.textContent = masteryPercent
    }
  }

  #updateMomentumText () {
    const progress = this.#updateProgress(this.momentumTarget, this.minMomentumValue, this.maxMomentumValue, this.momentumMaxDashValue, this.momentumLengthValue)
    let label

    switch (true) {
      case progress < 25:
        label = 'Slowing'
        break
      case progress < 56:
        label = 'Steady'
        break
      default:
        label = 'Strong'
    }

    if (this.hasMomentumTextTarget) {
      this.momentumTextTarget.textContent = label
    }
    if (this.hasMomentumTextMobileTarget) {
      this.momentumTextMobileTarget.textContent = label
    }
  }

  #updateMomentumPercent () {
    const progress = this.#updateProgress(this.momentumTarget, this.minMomentumValue, this.maxMomentumValue, this.momentumMaxDashValue, this.momentumLengthValue)
    if (this.hasMomentumPercentTarget) {
      this.momentumPercentTarget.textContent = `${Math.round(progress)}%`
    }
  }
}

stimulus.register('dashboard-progress-bar', DashboardProgressBarController)
